















import Vue from "vue";

import IconDrillListening from "@joyz/app-core/assets/icons/default/DrillListening.svg";
import IconDrillPronunciation from "@joyz/app-core/assets/icons/default/DrillPronunciation.svg";
import IconDrillVocabulary from "@joyz/app-core/assets/icons/default/DrillVocabulary.svg";
import IconLeft from "@joyz/app-core/assets/icons/black/ChevronLeft.svg";
import IconRight from "@joyz/app-core/assets/icons/black/ChevronRight.svg";

import { EXERCISE_TYPE, LOGGER_EVENTS } from "@tt-app/constants";
import { DrillState, ExerciseType } from "@tt-app/models/exercise";

interface Methods {
  goToPage: (pageIndex: number) => void;
  onGoLeft: () => void;
  onGoRight: () => void;
}

interface Computed {
  icons: { [key: string]: string };
  questionsCount: number;
  summaryIndex: number;
}

interface Props {
  drill: DrillState;
  exerciseType: ExerciseType;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "DrillBrowser",
  components: {},

  props: {
    drill: { type: Object as () => DrillState, required: true },
    exerciseType: { type: Number as () => ExerciseType, required: true }
  },

  data() {
    return {};
  },

  computed: {
    icons() {
      let cardIcon = "";
      switch (this.exerciseType) {
        case EXERCISE_TYPE.DRILL_LISTENING:
          cardIcon = IconDrillListening;
          break;
        case EXERCISE_TYPE.DRILL_PRONUNCIATION:
          cardIcon = IconDrillPronunciation;
          break;
        case EXERCISE_TYPE.DRILL_VOCABULARY:
          cardIcon = IconDrillVocabulary;
          break;
        default:
          throw new Error(`Unsupported drill exercise type: ${this.exerciseType}`);
      }

      return {
        card: cardIcon,
        left: IconLeft,
        right: IconRight
      };
    },
    questionsCount() {
      return this.drill.exercises.length;
    },
    summaryIndex() {
      return this.questionsCount + 1;
    }
  },

  methods: {
    goToPage(pageIndex) {
      if (pageIndex >= this.questionsCount && pageIndex !== this.summaryIndex) {
        // Jump from last question to summary
        if (this.drill.currentIndex < pageIndex) {
          this.$emit("go-to-page", this.summaryIndex);
        }
        // Jump from summary to last question
        else {
          this.$emit("go-to-page", this.questionsCount - 1);
        }
        return;
      }

      this.$emit("go-to-page", pageIndex);
    },

    onGoLeft() {
      this.$emit("logger-event", LOGGER_EVENTS.USER.EXERCISE_REVIEW_BACKWARD.SUCCESS);
    },

    onGoRight() {
      this.$emit("logger-event", LOGGER_EVENTS.USER.EXERCISE_REVIEW_FORWARD.SUCCESS);
    }
  }
});
